// Utility functions that were previously in @fastercise/common

/**
 * Wraps an async function call and returns { data, err } format
 * @param {Promise} promise - The promise to wrap
 * @returns {Promise<{data: any, err: Error|null}>}
 */
export const TryCall = async (promise) => {
  try {
    const data = await promise;
    return { data, err: null };
  } catch (err) {
    return { data: null, err };
  }
};

/**
 * Creates an async wrapper that returns { data, err } format
 * @param {Function} fn - The function to wrap
 * @returns {Function} - Wrapped function
 */
export const Async = (fn) => async (...args) => {
  try {
    const data = await fn(...args);
    return { data, err: null };
  } catch (err) {
    return { data: null, err };
  }
};

/**
 * Sleep utility function
 * @param {number} ms - Milliseconds to sleep
 * @returns {Promise}
 */
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms)); 